import React from "react";
import Feeds from "../myConnectPages/Feeds";
import Sidebar from "../layouts/sidebar/Sidebar";
import Footer from "../layouts/footer/Footer";
import ThemeProvider from "../theme";
import LeaderSpeak from "../myConnectPages/LeaderSpeak";
import CompanyWithHeart from "../myConnectPages/CompanyWithAHeart";
import Events from "../myConnectPages/Events";
import More from "../myConnectPages/More";
import JobDescription from "../component/JobReferral/JobDescription";
import JobReferral from "../myConnectPages/JobReferral";
import SinglePost from "../component/FeedPost.js/SinglePost";
import Awards from "../myConnectPages/Awards";
import Birthday from "../myConnectPages/Birthday";
import Weddings from "../myConnectPages/Weddings";
// import workstation from "../myConnectPages/workstation";
import Announcements from "../myConnectPages/Announcement";
import NewJoiner from "../myConnectPages/NewJoiner";
import Promotions from "../myConnectPages/Promotions";
import Accolades from "../myConnectPages/Accolades";
import BirthAnnouncement from "../myConnectPages/BirthAnnouncement";
import WorkAniversary from "../myConnectPages/WorkAniversary"
import Stories from "../myConnectPages/Stories";
import AssociateSpotlight from "../myConnectPages/AssociateSpotlight";
import ImageSlider from "../myConnectPages/ImageSlider";
import FindAssociates from "../component/MoreComponent/FindAssociates";
import OrganizationTree from "../component/OrganizationTree/OrganizationTree";
import SupportDirectory from "../component/MoreComponent/SupportDirectory";
import InternalJobs from "../component/MoreComponent/InternalJobs/InternalJobs";
import ImportantLinks from "../component/MoreComponent/ImportantLinks/ImportantLinks";
import MyFavorite from "../myConnectPages/MyFavorite";
import UserviewProfile from "../component/MoreComponent/UserviewProfile";
// import Breadcrumbs from "../features/breadcrumbs/Breadcrumbs";
import Breadcrumbs from "../component/Breadcrumbs";
import GeneratePost from "../myConnectPages/GeneratePost";
import Profile from "../myConnectPages/Profile";
import Settings from "../myConnectPages/Settings";
import routes from "../routesComponent/Routes";
// import DashboardTrash from "../pages/KnowledgeManagement/DashboardTrash";
// import TagAttachedFolder from "../pages/KnowledgeManagement/TagAttachedFolder";
const windowObject = window;

export function PrivateComponent() {
  <Breadcrumbs />
  let response = [
    {
      url: routes.root,
      page: (
        <ThemeProvider>
          <Sidebar window={windowObject}>
            <Feeds />
          </Sidebar>{" "}
        </ThemeProvider>
      ),
    },
    {
      url: routes.generativeAI,
      page: (
        <ThemeProvider>
          <Sidebar window={windowObject}>
            <GeneratePost />
          </Sidebar>{" "}
        </ThemeProvider>
      ),
    },
    {
      url: routes.profile,
      page: (
        <ThemeProvider>
          <Sidebar window={windowObject}>
            <Profile />
          </Sidebar>{" "}
        </ThemeProvider>
      ),
    },
    {
      url: routes.leaderSpeaks,
      page: (
        <ThemeProvider>
          <Sidebar window={windowObject}>
            <LeaderSpeak />
          </Sidebar>{" "}
        </ThemeProvider>
      ),
    },
    {
      url: routes.companyWithHearts,
      page: (
        <ThemeProvider>
          <Sidebar window={windowObject}>
            <CompanyWithHeart />
          </Sidebar>{" "}
        </ThemeProvider>
      ),
    },
    {
      url: routes.events,
      page: (
        <ThemeProvider>
          <Sidebar window={windowObject}>
            <Events />
          </Sidebar>{" "}
        </ThemeProvider>
      ),
    },
    {
      url: routes.birthdays,
      page: (
        <ThemeProvider>
          <Sidebar window={windowObject}>
            <Birthday />
          </Sidebar>{" "}
        </ThemeProvider>
      ),
    },
    {
      url: routes.announcements,
      page: (
        <ThemeProvider>
          <Sidebar window={windowObject}>
            <Announcements />
          </Sidebar>{" "}
        </ThemeProvider>
      ),
    },
    {
      url: routes.newJoiners,
      page: (
        <ThemeProvider>
          <Sidebar window={windowObject}>
            <NewJoiner />
          </Sidebar>{" "}
        </ThemeProvider>
      ),
    },
    {
      url: routes.promotions,
      page: (
        <ThemeProvider>
          <Sidebar window={windowObject}>
            <Promotions />
          </Sidebar>{" "}
        </ThemeProvider>
      ),
    },
    {
      url: routes.accolades,
      page: (
        <ThemeProvider>
          <Sidebar window={windowObject}>
            <Accolades />
          </Sidebar>{" "}
        </ThemeProvider>
      ),
    },
    {
      url: routes.birthAnnouncements,
      page: (
        <ThemeProvider>
          <Sidebar window={windowObject}>
            <BirthAnnouncement />
          </Sidebar>{" "}
        </ThemeProvider>
      ),
    },
    {
      url: routes.anniversaries,
      page: (
        <ThemeProvider>
          <Sidebar window={windowObject}>
            <WorkAniversary />
          </Sidebar>{" "}
        </ThemeProvider>
      ),
    },
    {
      url: routes.associateSpotlight,
      page: (
        <ThemeProvider>
          <Sidebar window={windowObject}>
            <AssociateSpotlight />
          </Sidebar>{" "}
        </ThemeProvider>
      ),
    },
    {
      url: routes.imageSlider,
      page: (
        <ThemeProvider>
          <Sidebar window={windowObject}>
            <ImageSlider />
          </Sidebar>{" "}
        </ThemeProvider>
      ),
    },
    {
      url: routes.stories,
      page: (
        <ThemeProvider>
          <Sidebar window={windowObject}>
            <Stories />
          </Sidebar>{" "}
        </ThemeProvider>
      ),
    },
    {
      url: routes.awards,
      page: (
        <ThemeProvider>
          <Sidebar window={windowObject}>
            <Awards />
          </Sidebar>{" "}
        </ThemeProvider>
      ),
    },
    {
      url: routes.more,
      page: (
        <ThemeProvider>
          <Sidebar window={windowObject}>
            <More />
          </Sidebar>{" "}
        </ThemeProvider>
      ),
    },
    {
      url: routes.jobDescriptionView+":id",
      page: (
        <ThemeProvider>
          <Sidebar window={windowObject}>
            <JobDescription />
          </Sidebar>{" "}
        </ThemeProvider>
      ),
    },
    {
      url: routes.jobReferral,
      page: (
        <ThemeProvider>
          <Sidebar window={windowObject}>
            <JobReferral />
          </Sidebar>{" "}
        </ThemeProvider>
      ),
    },
    {
      url: routes.organizationTree,
      page: (
        <ThemeProvider>
          <Sidebar window={windowObject}>
            <OrganizationTree />
          </Sidebar>{" "}
        </ThemeProvider>
      ),
    },
    {
      url: routes.weddings,
      page: (
        <ThemeProvider>
          <Sidebar window={windowObject}>
            <Weddings />
          </Sidebar>{" "}
        </ThemeProvider>
      ),
    },
    {
      url: routes.contactDirectory,
      page: (
        <ThemeProvider>
          <Sidebar window={windowObject}>
            <SupportDirectory />
          </Sidebar>{" "}
        </ThemeProvider>
      ),
    },
    {
      url: routes.findAssociate,
      page: (
        <ThemeProvider>
          <Sidebar window={windowObject}>
            <FindAssociates />
          </Sidebar>{" "}
        </ThemeProvider>
      ),
    },
    {
      url: routes.feedView+":id",
      page: (
        <ThemeProvider>
          <Sidebar window={windowObject}>
            <SinglePost />
          </Sidebar>{" "}
        </ThemeProvider>
      ),
    },
    {
      url: routes.internalJobs,
      page: (
        <ThemeProvider>
          <Sidebar window={windowObject}>
            <InternalJobs />
          </Sidebar>{" "}
        </ThemeProvider>
      ),
    },
    {
      url: routes.importantLinks,
      page: (
        <ThemeProvider>
          <Sidebar window={windowObject}>
            <ImportantLinks />
          </Sidebar>{" "}
        </ThemeProvider>
      ),
    },
    {
      url: routes.myFavorite,
      page: (
        <ThemeProvider>
          <Sidebar window={windowObject}>
            <MyFavorite />
          </Sidebar>{" "}
        </ThemeProvider>
      ),
    },
    {
      url: routes.settings,
      page: (
        <ThemeProvider>
          <Sidebar window={windowObject}>
            <Settings />
          </Sidebar>{" "}
        </ThemeProvider>
      ),
    },
    {
      url: routes.userViewProfileView+":id",
      page: (
        <ThemeProvider>
          <Sidebar window={windowObject}>
            <UserviewProfile />
          </Sidebar>{" "}
        </ThemeProvider>
      ),
    },
  ];
  return response;
}
